// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__abKH_","header":"ReportDetails_header__22ee9","title":"ReportDetails_title__3Y7QU","left":"ReportDetails_left__dKpQm"};